var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3830_5014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 6.9873H13.3335M15.3335 6.9873H13.3335M13.3335 6.9873V4.9873M13.3335 6.9873V8.98731",
    stroke: "#33AA44",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 13.6536V12.987C0.666504 10.4097 2.75584 8.32031 5.33317 8.32031V8.32031C7.9105 8.32031 9.99984 10.4097 9.99984 12.987V13.6536",
    stroke: "#33AA44",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 8.32064C6.80593 8.32064 7.99984 7.12673 7.99984 5.65397C7.99984 4.18121 6.80593 2.9873 5.33317 2.9873C3.86041 2.9873 2.6665 4.18121 2.6665 5.65397C2.6665 7.12673 3.86041 8.32064 5.33317 8.32064Z",
    stroke: "#33AA44",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3830_5014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.320312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.2c0a00bb5bc641015450224e98fc4416.svg";
export { ForwardRef as ReactComponent };